import { Action } from "redux"
import * as actions from "./actions"

export const initialState: Deployment.Deployment = {
    configurations: [],
    configurationsLoading: false,
    editor: {
        visible: false,
        source: undefined,
    },
    packageDiffs: {},
}

const handlers: {
    [action: string]: (
        state: Deployment.Deployment,
        props: Action,
    ) => Deployment.Deployment
} = {
    [actions.SET_INITIALIZED]: (state): Deployment.Deployment => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_CONFIGURATIONS]: (state) => ({
        ...state,
        configurationsLoading: true,
    }),

    [actions.REQUEST_INSTALLED_CONFIGURATIONS]: (state) => ({
        ...state,
        configurationsLoading: true,
    }),

    [actions.RECEIVE_CONFIGURATIONS]: (
        state,
        { configurations }: actions.ReceiveConfigurations,
    ): Deployment.Deployment => ({
        ...state,
        configurations,
        configurationsLoading: false,
    }),

    [actions.RECEIVE_SOURCE]: (
        state,
        { source }: actions.PackageSource,
    ): Deployment.Deployment => ({
        ...state,
        editor: { visible: true, source: source },
    }),

    [actions.CLOSE_EDITOR]: (state) => ({
        ...state,
        editor: { visible: false, source: undefined },
    }),

    [actions.RECEIVE_PACKAGE_DIFF]: (
        state,
        { packageDiff }: actions.ReceivePackageDiff,
    ): Deployment.Deployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [packageDiff.configuration.id]: {
                configuration: packageDiff.configuration,
                baselineTime: packageDiff.baselineTime,
                snapshotTime: packageDiff.snapshotTime,
                changes: packageDiff.changes,
                addinDiffs: [],
                addinDiffsLoading: false,
            },
        },
    }),

    [actions.REQUEST_PACKAGE_ADDIN_DIFFS]: (
        state,
        { id }: actions.ConfigurationId,
    ): Deployment.Deployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [id]: {
                ...state.packageDiffs[id],
                addinDiffsLoading: true,
            },
        },
    }),

    [actions.RECEIVE_PACKAGE_ADDIN_DIFFS]: (
        state,
        { id, addinDiffs }: actions.ReceivePackageAddinDiffs,
    ): Deployment.Deployment => ({
        ...state,
        packageDiffs: {
            ...state.packageDiffs,
            [id]: {
                ...state.packageDiffs[id],
                addinDiffs,
                addinDiffsLoading: false,
            },
        },
    }),
}

export default function reducer(
    state: Deployment.Deployment = initialState,
    action: Action,
): Deployment.Deployment {
    const handler: (
        state: Deployment.Deployment,
        action: Action,
    ) => Deployment.Deployment = handlers[action.type]
    return handler ? handler(state, action) : state
}
